// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"f1-z"};